import { useState } from 'react';
import { EmployeeList } from './components/employee-list';
import { Filters } from './components/filters';
import { StatusFilter } from './components/filters/interfaces';
import { ContentBox } from '@/components/shared/content-box';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useEmployees } from '@/data/employees';
import type { Company } from '@/data/employees/interfaces';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { useSetTitle } from '@/hooks/use-set-title';

const title = 'Gestão de colaboradores';

export const EmployerManagement = () => {
  useSetTitle(title);
  const { bootstrap } = useBootstrapData();
  const companyIdByUser = bootstrap?.info?.colaborador?.empresa_id;
  const [selectedCompany, setSelectedCompany] = useState<Company | null>(null);
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [searchParams, setSearchParams] = useState({
    page: '1',
    limit: '10',
    company_id: String(companyIdByUser || 0),
    searchTerm: '',
    searchSelectedStatus: StatusFilter.Registered,
  });
  const { companies, employees, isFetching } = useEmployees({ searchParams });

  const handleSearch = () => {
    setSearchParams({
      ...searchParams,
      searchTerm: localSearchTerm,
      page: '1',
    });
  };

  const handleStatusChange = (status: string) => {
    setSearchParams({
      ...searchParams,
      searchSelectedStatus: status as StatusFilter,
      page: '1',
    });
  };

  const handleCompanyChange = (company: Company | null) => {
    setSelectedCompany(company);
    setSearchParams({
      ...searchParams,
      company_id: company?.id ?? String(companyIdByUser || 0),
      page: '1',
    });
  };

  return (
    <PageContainer>
      <PageHeader
        title={title}
        description="Visualize, adicione, edite e remova colaboradores."
      />
      <ContentBox>
        <Filters
          companies={companies?.rows || []}
          selectedCompany={selectedCompany}
          setSelectedCompany={handleCompanyChange}
          localSearchTerm={localSearchTerm}
          setLocalSearchTerm={setLocalSearchTerm}
          handleSearch={handleSearch}
          loading={isFetching}
          statusValue={searchParams.searchSelectedStatus}
          onStatusChange={handleStatusChange}
        />
        <EmployeeList
          employees={employees?.rows || []}
          onPaginationModelChange={(newPage) =>
            setSearchParams({
              ...searchParams,
              page: String(newPage.page + 1),
              limit: String(newPage.pageSize),
            })
          }
          pageState={{
            isLoading: isFetching,
            data: employees?.rows || [],
            total: employees?.count || 0,
            page: Number(searchParams.page) - 1,
            pageSize: Number(searchParams.limit),
          }}
        />
      </ContentBox>
    </PageContainer>
  );
};
